module.exports = __webpack_public_path__ + "img/Image_1__Third_Canal_990_35_2.5762dfb1.jpg";